module.exports = __webpack_public_path__ + "img/馬原愛斗.7d7f433b.jpg";